import React, { useState } from 'react'
import "./Contact.css"
import Breadcrumb_comp from '../common_component/breadcrumb-comp/Breadcrumb_comp'
import Common_heading from '../common_component/common_heading/Common_heading'
import Contact_card from './contact_card/Contact_card'
import Contact_form from './contact_form/Contact_form'
import ScrollToTop from '../ScrollTotop/ScrollTotop'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faXmark } from '@fortawesome/free-solid-svg-icons'

function Contact() {
    const [showMap, setShowMap] = useState(false);
    const [mapAnimation, setMapAnimation] = useState(""); // control animation class

    const handleClick = () => {
        setShowMap(true);
        setMapAnimation("scale-up-ver-bottom");
    };

    const handleCloseMap = () => {
        // Start scale-down animation
        setMapAnimation("scale-down-ver-bottom");

        // Wait for animation to complete (500ms typical for CSS)
        setTimeout(() => {
            setShowMap(false);
        }); // Adjust duration to match CSS animation time
    };

    return (
        <>
            <section className='Contact'>
                <div className="container">

                    {!showMap && (
                        <>
                            <Breadcrumb_comp
                                breadcrumbs={[
                                    { label: "Home", link: "/", isActive: false },
                                    { label: "Contact", link: "", isActive: true },
                                ]}
                            />


                            <Common_heading
                                title="LET’S CONNECT"
                                subTitle="Whether You're Looking To Partner, Inquire, Or Simply Learn More — We’re Here To Help."
                            />
                            <Contact_card />

                            <Contact_form mapOnClick={handleClick} />
                        </>
                    )}


                    {showMap && (
                        <>
                            <ScrollToTop />


                            <div className={`overlay_map_holder ${mapAnimation}`} >

                                <Breadcrumb_comp
                                    breadcrumbs={[
                                        { label: "Home", link: "/", isActive: false },
                                        { label: "Contact", link: "", isActive: true },
                                    ]}
                                />
                                <Common_heading
                                    title="CONTACT US"
                                />
                                <div className="row me-0 ms-0 justify-content-center align-items-center h-100">
                                    <div className="col-xl-6 col-md-8 col-sm-12">
                                        <div className="map_holder" style={{ position: 'relative' }}>

                                            <iframe
                                                width="100%"
                                                height="100%"
                                                frameBorder="0"
                                                scrolling="no"
                                                marginHeight="0"
                                                marginWidth="0"
                                                src="https://maps.google.com/maps?q=UAE%20Al%20Shohada%20Road%2C%20AL%20Hamra%20Industrial%20Zone-FZ%2C%20RAS%20AL%20KHAIMAH%2C%20United%20Arab%20Emirates&t=m&z=2&ie=UTF8&iwloc=B&output=embed"
                                                title="Google Map"
                                            ></iframe>
                                        </div>
                                    </div>
                                </div>

                                {/* ❌ Cross Icon */}
                                <span
                                    className='cross_icon'
                                    onClick={handleCloseMap}
                                >
                                    <FontAwesomeIcon icon={faXmark} />
                                </span>

                            </div>
                        </>
                    )}
                </div>
            </section >
        </>
    )
}

export default Contact
